import React, { useState, useEffect } from 'react'
import GenderList from './GenderList'
import NameResults from './NameResults'
import Information from '../Common/Information'

const NameDetail = (props) => {
    
    const [fullData] = useState(props.ResultData);
    const [babyNames] = useState(props.BabyData);
    const [similarBabyNames] = useState(props.SimilarData);
    const [similarData, setSimilarData] = useState(false)
    const [parent] = useState(false)

    /* Call the below function on similar data props on changed */    
    useEffect(() => {
        if(props.SimilarData !== null){
            setSimilarData(true)
        } else {
            setSimilarData(false)
        }     
    },[props.SimilarData]);
        
    /* This component will return the details of the searched name */
    return (
        <React.Fragment>
            {
                babyNames !== null ?
                babyNames.map((data, index) => {
                    return (
                        <div key={index} className="blk blk-name-result">
                            <div className="lftblk">
                                <label>{fullData.resultHeaderTitles.name} :</label> <span>{data.name}</span>
                                <br />
                                <label>{fullData.resultHeaderTitles.gender} :</label>
                                {                                            
                                    <GenderList key={index+data.gender} icons={fullData.genderList} data={data.gender} />
                                }
                            </div>
                            <div className="rgtblk">
                                <label>{fullData.resultHeaderTitles.meaning} :</label>
                                <p>
                                    {data.meaning}
                                </p>
                            </div>                                
                        </div>
                    ) 
                }) :
                <div className="blk blk-name-result">
                    {
                        /* If i dont have a searched name but i have a similar results, this information block will display */
                    }
                    <Information infomsg={fullData.babyNamesTitle} />
                </div>
            }
            {
                /* If i have the similar results for the searched category, then the NameResults component will display those */
                similarData &&  <NameResults fullData={fullData} similarBabyNames={similarBabyNames} parent={parent} {...props}  />
            }
        </React.Fragment>
    )

}

export default NameDetail
